





















helpers = require('../../../helpers.coffee')

view_model = {
  components:
    listItem: require('./list_item')

  data: ->
    current_user: Session.current_user
    notifications: []
    next_page: 1
    loading: false

  methods:
    updateNotification: (notif) ->
      @notifications.replaceById(notif)

    loadNotifications: (filters) ->
      return if @loading || !@next_page
      @loading = true
      params = if filters then { q: filters, page: @next_page } else { page: @next_page }
      @notifications_resource.index(@loadNotificationsSuccess, @unknownError, params: params)

    loadNotificationsSuccess: (data) ->
      @loading = false
      @notifications = @notifications.concat(data.notifications)
      @next_page = data.meta.next_page

    filter: (filters) ->
      @next_page = 1
      @notifications = []
      @loadNotifications(filters)

  computed:
    show_user_filter: ->
      @current_user.isManager()

  created: ->
    @notifications_resource = new NotificationsResource()
    @loadNotifications()
    EventsBus.$on 'NotificationTask::Done', @updateNotification

  beforeDestroy: ->
    EventsBus.$off 'NotificationTask::Done', @updateNotification
}

exports.default = helpers.vue_include(view_model)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/index.vue